/**
 * opora-tool-prefill.js  v1.0
 * Author: Opora Editorial Team
 *
 * Reads URL params on tool pages and prefills matching form inputs.
 *
 * URL param protocol:
 *   ?from=<source_tool_slug>&fields_b64=<base64-encoded-JSON>
 *
 * fields_b64 decodes to an object:
 *   { "input_name_or_id": "value", ... }
 *
 * Example:
 *   /pages/bid-drafter?from=rfp_decoder&fields_b64=eyJjbGllbnRfbmFtZSI6Ik...
 *
 * Supported cross-tool flows:
 *   rfp_decoder     → bid-drafter
 *   walkthrough_voice → bid-drafter
 *   sow_builder     → bid-drafter  (Q36c)
 *   goal_tracking   → weekly_pulse  (Q36c)
 */
(function () {
  'use strict';

  function decodeFields(b64) {
    try {
      var json = atob(b64);
      return JSON.parse(json);
    } catch (e) {
      return null;
    }
  }

  function prefillField(name, value, opts) {
    opts = opts || {};
    // Try id first, then name attribute, then data-field-name, then D4 calc field
    var el = document.getElementById(name) ||
             document.querySelector('[name="' + name + '"]') ||
             document.querySelector('[data-field-name="' + name + '"]') ||
             document.querySelector('[data-calc-field="' + name + '"]');

    if (!el) return false;

    if (!opts.force && el.type !== 'checkbox' && el.tagName !== 'SELECT') {
      var current = String(el.value || '').trim();
      if (current && el.getAttribute('data-prefilled') !== '1') return false;
    }

    if (el.tagName === 'SELECT') {
      var found = false;
      for (var i = 0; i < el.options.length; i++) {
        if (el.options[i].value === value || el.options[i].text === value) {
          el.selectedIndex = i;
          found = true;
          break;
        }
      }
      if (found) el.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (el.type === 'checkbox') {
      el.checked = (value === 'true' || value === '1' || value === true);
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (el.type === 'radio') {
      // Handle radio groups by name
      var radios = document.querySelectorAll('[name="' + name + '"]');
      radios.forEach(function (r) {
        if (r.value === value) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    } else {
      el.value = value;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
    el.setAttribute('data-prefilled', '1');
    return true;
  }

  function applyBidBillRate(rate) {
    var clean = String(rate == null ? '' : rate).replace(/[^\d.]/g, '');
    if (!clean) return 0;
    var filled = 0;
    var modeEl = document.getElementById('opf_bd-pricing-mode') || document.getElementById('bd-pricing-mode');
    if (modeEl && String(modeEl.value || '') !== 'bill_rate') {
      modeEl.value = 'bill_rate';
      modeEl.dispatchEvent(new Event('change', { bubbles: true }));
      filled++;
    }
    ['opf_bd-bill-rate', 'bd-bill-rate'].forEach(function (f) {
      if (prefillField(f, clean)) filled++;
    });
    return filled;
  }

  function appendNotesField(ids, line) {
    if (!line) return 0;
    var filled = 0;
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var cur = String(el.value || '').trim();
      if (cur && el.getAttribute('data-prefilled') !== '1') return;
      el.value = cur ? (cur + '\n\n' + line) : line;
      el.setAttribute('data-prefilled', '1');
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      filled++;
    });
    return filled;
  }

  function showPrefillBanner(fromTool) {
    var toolNames = {
      'rfp_decoder': 'RFP Decoder',
      'walkthrough_voice': 'Walkthrough Voice',
      'scope_of_work': 'SOW Generator',
      'scope-of-work-generator': 'SOW Generator',
      'scripts-library': 'Scripts Library',
      'ask-opora': 'Ask Opora',
      'previous_tool': 'previous tool',
    };
    var sourceName = toolNames[fromTool] || fromTool.replace(/_/g, ' ');

    var banner = document.createElement('div');
    banner.className = 'opora-prefill-banner';
    banner.setAttribute('role', 'status');
    banner.innerHTML =
      '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">' +
      '<path d="M7.5 1L9.5 5.5H14L10.5 8.5L12 13L7.5 10L3 13L4.5 8.5L1 5.5H5.5L7.5 1z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span>Form pre-filled with data from <strong>' + sourceName + '</strong></span>' +
      '<button type="button" class="opora-prefill-banner__dismiss" aria-label="Dismiss">&times;</button>';

    banner.style.cssText =
      'display:flex;align-items:center;gap:8px;padding:10px 14px;' +
      'background:rgba(31,138,138,0.08);border:1px solid rgba(31,138,138,0.25);' +
      'border-radius:8px;font:500 13px/1.4 var(--font-main,-apple-system,sans-serif);' +
      'color:#1f8a8a;margin-bottom:16px;';

    banner.querySelector('.opora-prefill-banner__dismiss').style.cssText =
      'margin-left:auto;background:none;border:none;cursor:pointer;font-size:16px;color:inherit;line-height:1;padding:0 2px;';

    banner.querySelector('.opora-prefill-banner__dismiss')
      .addEventListener('click', function () { banner.remove(); });

    // Insert before first form or at top of main content
    var target = document.querySelector('form') ||
                 document.querySelector('.oa-tool-wrap') ||
                 document.querySelector('main') ||
                 document.body;

    if (target.tagName === 'FORM') {
      target.parentNode.insertBefore(banner, target);
    } else {
      target.insertBefore(banner, target.firstChild);
    }
  }

  function run() {
    var params = new URLSearchParams(location.search);
    var from = params.get('from');
    var fieldsB64 = params.get('fields_b64');
    var artifactId = params.get('artifact_id');
    var filled = 0;

    /* Simple query-param prefill (bid-drafter, D4 tools) */
    var simpleMap = {
      sqft: ['bd-sqft', 'opf_bd-sqft', 'sqft', 'opf_square_footage', 'square_footage'],
      notes: ['opConvoInput', 'bd-notes', 'notes', 'opf_bd-notes'],
      state: ['bd-state', 'opf_bd-state', 'state', 'opf_state'],
      deal_vertical: ['bd-vertical', 'opf_bd-vertical', 'deal_vertical', 'vertical', 'opf_vertical'],
      specialty: ['opf_vertical', 'vertical', 'bd-vertical', 'opf_bd-vertical'],
      role: ['opf_role', 'role'],
      company: ['opf_brand', 'brand', 'opf_company', 'company', 'company_name'],
      city: ['bd-city', 'opf_bd-city', 'city'],
      hourlyRate: ['opf_bd-bill-rate', 'bd-bill-rate'],
      crewHours: ['opConvoInput', 'bd-notes', 'notes', 'opf_bd-notes'],
      overhead_pct: ['opf_overhead_pct', 'overhead_pct'],
      wage_rate: ['opf_base_wage', 'opf_wage_rate', 'wage_rate', 'base_wage'],
      wage: ['opf_base_wage', 'opf_wage_rate', 'wage_rate', 'base_wage'],
      base_wage: ['opf_base_wage', 'opf_wage_rate', 'wage_rate', 'base_wage'],
      wage_min: ['opf_base_wage', 'base_wage'],
      base_min: ['opf_base_wage', 'base_wage'],
      hourlyRate: ['opf_bd-bill-rate', 'bd-bill-rate']
    };
    Object.keys(simpleMap).forEach(function (param) {
      var val = params.get(param);
      if (!val) return;
      if (param === 'hourlyRate') {
        /* Bid Drafter wants bill rate; Hire Right locks base wage from the same key when present */
        var slugElHr = document.getElementById('_d4_tool_slug');
        var slugHr = slugElHr && slugElHr.value;
        if (slugHr === 'hire-right') {
          if (prefillField('opf_base_wage', String(val).replace(/[^\d.]/g, ''))) filled++;
          return;
        }
        if (applyBidBillRate(val)) filled++;
        return;
      }
      if (param === 'crewHours') {
        filled += appendNotesField(simpleMap.crewHours, 'Crew hours (from Ask Opora): ' + val);
        return;
      }
      if (param === 'wage_min' || param === 'base_min') {
        var hi = params.get(param === 'wage_min' ? 'wage_max' : 'base_max');
        var loN = Number(String(val).replace(/[^\d.]/g, ''));
        var hiN = hi ? Number(String(hi).replace(/[^\d.]/g, '')) : 0;
        var mid = (loN > 0 && hiN > 0) ? ((loN + hiN) / 2) : loN;
        if (mid > 0) {
          var midStr = (Math.round(mid * 100) / 100).toFixed(2);
          var forceWage = (params.get('from') || '') === 'hire-right';
          simpleMap[param].forEach(function (field) {
            if (prefillField(field, midStr, forceWage ? { force: true } : undefined)) filled++;
          });
        }
        return;
      }
      if (param === 'base_wage' || param === 'wage' || param === 'wage_rate') {
        var forceBw = (params.get('from') || '') === 'hire-right';
        var cleanBw = String(val).replace(/[^\d.]/g, '');
        simpleMap[param].forEach(function (field) {
          if (prefillField(field, cleanBw, forceBw ? { force: true } : undefined)) filled++;
        });
        return;
      }
      simpleMap[param].forEach(function (field) {
        if (prefillField(field, val)) filled++;
      });
    });

    if (from && fieldsB64) {
      var fields = decodeFields(fieldsB64);
      if (fields && typeof fields === 'object') {
        Object.keys(fields).forEach(function (key) {
          if (prefillField(key, fields[key])) filled++;
        });
      }
    }

    /* Generic ?prefill=<JSON> handoff — emitted by the unified action bar and by
       D4 tool renders (e.g. walkthrough → bid-drafter). applyPayload maps canonical
       keys (square_footage/state/vertical/…) onto each tool's field variants and
       shows its own banner, so we don't double-count into `filled`. */
    var prefillJson = params.get('prefill');
    var prefillApplied = false;
    if (prefillJson) {
      try {
        var pf = JSON.parse(prefillJson);
        if (pf && typeof pf === 'object') {
          applyPayload(pf, from || 'previous_tool');
          prefillApplied = true;
        }
      } catch (e) {}
    }

    if (applyStashedPrefill()) {
      prefillApplied = true;
    }

    if (filled > 0 && from) {
      showPrefillBanner(from);
    } else if (filled > 0) {
      showPrefillBanner('previous_tool');
    }

    if (artifactId) {
      loadArtifactPrefill(artifactId, from);
    }

    if (filled > 0 || prefillApplied) {
      cleanUrlParams(['from', 'fields_b64', 'sqft', 'notes', 'state', 'deal_vertical', 'specialty', 'role', 'company', 'city', 'prefill', 'hourlyRate', 'crewHours', 'overhead_pct', 'wage_rate', 'wage', 'base_wage', 'wage_min', 'wage_max', 'base_min', 'base_max', 'loaded_min', 'loaded_max', 'team_size', 'everify', 'classification', 'burden', 'overtime']);
    }
  }

  function cleanUrlParams(keys) {
    var qs = location.search.replace(/^\?/, '');
    if (!qs) return;
    keys.forEach(function (k) {
      qs = qs.replace(new RegExp('(^|&)' + k + '=[^&]*', 'g'), '');
    });
    qs = qs.replace(/^&/, '').replace(/&&/g, '&');
    window.history.replaceState({}, '', location.pathname + (qs ? '?' + qs : ''));
  }

  function applyPayload(payload, fromSlug) {
    if (!payload || typeof payload !== 'object') return 0;
    var filled = 0;
    var force = /hire-right|1099/i.test(String(fromSlug || payload.source_tool || payload.from || ''));
    function pf(name, val) {
      if (prefillField(name, val, force ? { force: true } : undefined)) filled++;
    }
    var text = payload.transcript || payload.prefill_text || payload.recording || payload.scope_summary || payload.notes;
    if (text) {
      ['opConvoInput', 'wv-recording', 'opf_wv-recording', 'bd-notes', 'notes'].forEach(function (f) {
        if (prefillField(f, text)) filled++;
      });
    }
    if (payload.sqft || payload.total_sqft || payload.square_footage) {
      var sq = String(payload.sqft || payload.total_sqft || payload.square_footage).trim();
      // type=number rejects "12,000" — normalize to digits so the value actually sticks
      var sqDigits = sq.replace(/[^\d.]/g, '');
      var sqNum = Number(sqDigits);
      var sqClean = (sqDigits && isFinite(sqNum) && sqNum > 0) ? String(Math.round(sqNum)) : sq;
      ['bd-sqft', 'opf_bd-sqft', 'sqft', 'square_footage', 'sow-total-sqft', 'opf_square_footage', 'total_sqft'].forEach(function (f) {
        if (prefillField(f, sqClean)) filled++;
      });
      // Keep SOW wizard state in sync when the DOM was prefilled after/before init
      try {
        if (window.OporaScopeGen && typeof window.OporaScopeGen._getState === 'function' &&
            typeof window.OporaScopeGen._setState === 'function' && sqClean) {
          window.OporaScopeGen._setState({ totalSqft: sqClean });
        }
      } catch (e) { /* ignore */ }
    }
    if (payload.vertical || payload.deal_vertical) {
      var v = payload.vertical || payload.deal_vertical;
      ['bd-vertical', 'opf_bd-vertical', 'deal_vertical', 'vertical', 'opf_vertical'].forEach(function (f) {
        if (prefillField(f, v)) filled++;
      });
    }
    if (payload.state) {
      ['bd-state', 'opf_bd-state', 'state', 'opf_state'].forEach(function (f) {
        pf(f, payload.state);
      });
    }
    if (payload.company_name && !payload.client_name && !payload.facility_name) {
      ['opf_bd-company', 'bd-company', 'opf_cr-company'].forEach(function (f) {
        if (prefillField(f, payload.company_name)) filled++;
      });
    }
    if (payload.target_monthly || payload.scaled_monthly || payload['opf_bd-target-monthly']) {
      var tm = payload.target_monthly || payload.scaled_monthly || payload['opf_bd-target-monthly'];
      if (prefillField('opf_bd-pricing-mode', 'target_monthly')) filled++;
      if (prefillField('bd-pricing-mode', 'target_monthly')) filled++;
      if (prefillField('opf_bd-target-monthly', String(tm))) filled++;
      if (prefillField('bd-target-monthly', String(tm))) filled++;
    }
    if (payload.bid_price_total != null && payload.bid_price_total !== '') {
      if (prefillField('opf_bid_price_total', String(payload.bid_price_total))) filled++;
      if (prefillField('bid_price_total', String(payload.bid_price_total))) filled++;
    }
    var billRate = payload.bill_rate || payload.hourly_rate || payload.hourlyRate;
    if (billRate) filled += applyBidBillRate(billRate);
    if (payload.base_wage || payload.wage_rate || payload.wage || payload.hourly_rate || payload.hourlyRate) {
      var wr = String(payload.base_wage || payload.wage_rate || payload.wage || payload.hourly_rate || payload.hourlyRate).replace(/[^\d.]/g, '');
      pf('opf_base_wage', wr);
      pf('opf_wage_rate', wr);
      pf('wage_rate', wr);
      pf('base_wage', wr);
    }
    if (!payload.base_wage && !payload.wage_rate && !payload.wage && (payload.wage_min || payload.base_min)) {
      var loP = Number(String(payload.wage_min || payload.base_min).replace(/[^\d.]/g, ''));
      var hiP = Number(String(payload.wage_max || payload.base_max || '').replace(/[^\d.]/g, ''));
      var midP = (loP > 0 && hiP > 0) ? ((loP + hiP) / 2) : loP;
      if (midP > 0) {
        var midPs = (Math.round(midP * 100) / 100).toFixed(2);
        pf('base_wage', midPs);
        pf('opf_base_wage', midPs);
      }
    }
    if (payload.contractor_rate) {
      pf('contractor_rate', String(payload.contractor_rate).replace(/[^\d.]/g, ''));
    }
    if (payload.crew_hours || payload.crewHours || payload.labor_hours) {
      var hrs = payload.crew_hours || payload.crewHours || payload.labor_hours;
      filled += appendNotesField(['opConvoInput', 'bd-notes', 'notes', 'opf_bd-notes'], 'Crew hours (from Ask Opora): ' + hrs);
    }
    if (payload.overhead_pct || payload.gross_margin || payload.grossMargin) {
      var op = String(payload.overhead_pct || payload.gross_margin || payload.grossMargin).replace(/[^\d.]/g, '');
      if (prefillField('opf_overhead_pct', op)) filled++;
      if (prefillField('overhead_pct', op)) filled++;
    }
    if (payload.client_name || payload.facility_name) {
      var cn = payload.client_name || payload.facility_name;
      ['bd-company', 'opf_bd-company', 'client_name', 'sow-facility-name'].forEach(function (f) {
        if (prefillField(f, cn)) filled++;
      });
    }
    if (payload.building_type || payload.facility_type) {
      var bt = payload.building_type || payload.facility_type;
      ['bd-building', 'opf_bd-building', 'sow-facility-type'].forEach(function (f) {
        if (prefillField(f, bt)) filled++;
      });
    }
    if (payload.num_floors) {
      if (prefillField('sow-num-floors', String(payload.num_floors))) filled++;
    }
    if (payload.hours_of_operation) {
      if (prefillField('sow-hours-op', payload.hours_of_operation)) filled++;
    }
    if (payload.access_requirements) {
      if (prefillField('sow-access-req', payload.access_requirements)) filled++;
    }
    if (payload.scope_summary && document.getElementById('sow-wizard-root')) {
      if (prefillField('sow-facility-name', payload.client_name || payload.facility_name || '')) filled++;
    }
    Object.keys(payload).forEach(function (key) {
      if (prefillField(key, payload[key])) filled++;
    });
    if (filled > 0 && fromSlug) showPrefillBanner(fromSlug);
    return filled;
  }

  function applyStashedPrefill() {
    var slugEl = document.getElementById('_d4_tool_slug');
    var slug = slugEl && slugEl.value;
    if (!slug) return 0;
    try {
      var raw = sessionStorage.getItem('opora_prefill_' + slug);
      if (!raw) return 0;
      sessionStorage.removeItem('opora_prefill_' + slug);
      var payload = JSON.parse(raw);
      return applyPayload(payload, payload && payload.source_tool ? payload.source_tool : 'previous_tool');
    } catch (e) {
      return 0;
    }
  }

  function loadArtifactPrefill(id, fromSlug) {
    var edge = window.OporaEdge || {};
    var fetchFn = (typeof edge.fetchApi === 'function')
      ? function (p) { return edge.fetchApi(p); }
      : function (p) { return fetch((window.OPORA_WORKER_URL || 'https://api.oporasupply.com') + p); };
    fetchFn('/api/artifacts/' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var art = data.data || data.artifact || data;
        var payload = art.input_payload || art.metadata || {};
        if (art.content_markdown || art.body_markdown) {
          payload = Object.assign({
            prefill_text: art.content_markdown || art.body_markdown
          }, payload);
        }
        applyPayload(payload, fromSlug || art.source_tool || 'library');
      })
      .catch(function () {});
  }

  document.addEventListener('opora:handoff-ready', function (e) {
    var d = e.detail || {};
    if (d.payload) applyPayload(d.payload, d.fromSlug);
  });

  /* ── Init — wait for DOM ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    // Some tool pages build their DOM via JS after load — retry up to 5×
    run();
    var attempts = 0;
    var retry = setInterval(function () {
      attempts++;
      run();
      if (attempts >= 5) clearInterval(retry);
    }, 400);
  }

  /* ── Expose helpers for tool JS to call programmatically ── */
  window.oporaPrefill = {
    /**
     * Navigate to targetPath with prefilled fields.
     * @param {string} targetPath - e.g. '/pages/bid-drafter'
     * @param {string} fromSlug   - e.g. 'rfp_decoder'
     * @param {Object} fields     - { fieldName: value, ... }
     */
    navigate: function (targetPath, fromSlug, fields) {
      var b64 = btoa(JSON.stringify(fields));
      var url = targetPath + '?from=' + encodeURIComponent(fromSlug) + '&fields_b64=' + encodeURIComponent(b64);
      location.href = url;
    },
    applyPayload: applyPayload
  };

})();
